{
  "REPORT": {
    "HEADER": "المحادثات",
    "LOADING_CHART": "تحميل بيانات الرسم البياني...",
    "NO_ENOUGH_DATA": "لم يتم جمع بيانات بقدر كافي لإنشاء التقرير، الرجاء المحاولة مرة أخرى لاحقاً.",
    "DOWNLOAD_AGENT_REPORTS": "تحميل تقارير وكيل",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "المحادثات",
        "DESC": "(الإجمالي)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "الرسائل الواردة",
        "DESC": "(الإجمالي)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "الرسائل الصادرة",
        "DESC": "(الإجمالي)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "وقت الاستجابة الأولى",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الرد الأول هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_TIME": {
        "NAME": "وقت إغلاق المحادثات",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الحل هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "(الإجمالي)"
      },
      "REPLY_TIME": {
        "NAME": "وقت انتظار العميل",
        "TOOLTIP_TEXT": "وقت الانتظار هو {metricValue} (بناء على ردود {conversationCount})",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "اليوم",
      "YESTERDAY": "أمس",
      "LAST_7_DAYS": "آخر 7 أيام",
      "LAST_30_DAYS": "آخر 30 يوماً",
      "THIS_MONTH": "هذا الشهر",
      "LAST_MONTH": "الشهر الماضي",
      "LAST_3_MONTHS": "آخر 3 أشهر",
      "LAST_6_MONTHS": "آخر 6 أشهر",
      "LAST_YEAR": "العام الماضي",
      "CUSTOM_DATE_RANGE": "تحديد نطاق المدة"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "تطبيق",
      "PLACEHOLDER": "اختر نطاق المدة"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "تجميع بواسطة",
    "DURATION_FILTER_LABEL": "المدة",
    "GROUPING_OPTIONS": {
      "DAY": "اليوم",
      "WEEK": "الأسبوع",
      "MONTH": "الشهر",
      "YEAR": "السنة"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "اليوم"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "اليوم"
      },
      {
        "id": 2,
        "groupBy": "الأسبوع"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "اليوم"
      },
      {
        "id": 2,
        "groupBy": "الأسبوع"
      },
      {
        "id": 3,
        "groupBy": "الشهر"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "اليوم"
      },
      {
        "id": 2,
        "groupBy": "الأسبوع"
      },
      {
        "id": 3,
        "groupBy": "الشهر"
      }
    ],
    "BUSINESS_HOURS": "ساعات العمل",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "لم يتم العثور على النتائج"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "المحادثات: {count}",
      "RESULT_COUNT_MESSAGE": "الرسائل: {count}",
      "EMPTY": "لم يتم العثور على سجلات لهذا العمود.",
      "ERROR": "تعذر تحميل السجلات. يرجى المحاولة مرة أخرى.",
      "LOAD_MORE": "تحميل المزيد",
      "PREVIOUS_BUCKET": "العمود السابق",
      "NEXT_BUCKET": "العمود التالي",
      "UNKNOWN_CONTACT": "جهة اتصال غير معروفة",
      "UNKNOWN_INBOX": "صندوق وارد غير معروف",
      "UNASSIGNED_AGENT": "غير مسندة",
      "NO_MESSAGE_CONTENT": "لا يوجد محتوى للرسالة",
      "MESSAGE_CREATED_AT": "أُنشئت الرسالة في {time}",
      "EVENT_OCCURRED_AT": "وقع الحدث في {time}",
      "INCOMING_MESSAGE": "رسالة واردة",
      "OUTGOING_MESSAGE": "رسالة صادرة",
      "VIEW_ALL": "عرض في المحادثات",
      "VIEW_ALL_LIMIT": "يمكن فتح الأعمدة التي تحتوي على {limit} محادثة كحد أقصى فقط في قائمة المحادثات.",
      "HIDDEN_COUNT": "غير معروضة لأنك لست عضوًا في صندوق الوارد الخاص بها: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "نظرة عامة للوكلاء",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "جاري جلب بيانات الرسم البياني...",
    "NO_ENOUGH_DATA": "لم يتم جمع بيانات بقدر كافي لإنشاء التقرير، الرجاء المحاولة مرة أخرى لاحقاً.",
    "DOWNLOAD_AGENT_REPORTS": "تنزيل تقارير الوكيل",
    "FILTER_DROPDOWN_LABEL": "اختر وكيل",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "المحادثات",
        "DESC": "(الإجمالي)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "الرسائل الواردة",
        "DESC": "(الإجمالي)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "الرسائل الصادرة",
        "DESC": "(الإجمالي)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "وقت الاستجابة الأولى",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الرد الأول هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_TIME": {
        "NAME": "وقت إغلاق المحادثات",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الحل هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "آخر 7 أيام"
      },
      {
        "id": 1,
        "name": "آخر 30 يوماً"
      },
      {
        "id": 2,
        "name": "آخر 3 أشهر"
      },
      {
        "id": 3,
        "name": "آخر 6 أشهر"
      },
      {
        "id": 4,
        "name": "العام الماضي"
      },
      {
        "id": 5,
        "name": "تحديد نطاق المدة"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "تطبيق",
      "PLACEHOLDER": "اختر نطاق المدة"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "نظرة عامة على التسميات",
    "DESCRIPTION": "تتبّع أداء التسميات من خلال مقاييس رئيسية تشمل المحادثات وأوقات الاستجابة وأوقات الحل والحالات المحلولة.",
    "LOADING_CHART": "تحميل بيانات الرسم البياني...",
    "NO_ENOUGH_DATA": "لم يتم جمع بيانات بقدر كافي لإنشاء التقرير، الرجاء المحاولة مرة أخرى لاحقاً.",
    "DOWNLOAD_LABEL_REPORTS": "تحميل تقارير التسمية",
    "FILTER_DROPDOWN_LABEL": "حدد التسمية",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "المحادثات",
        "DESC": "(الإجمالي)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "الرسائل الواردة",
        "DESC": "(الإجمالي)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "الرسائل الصادرة",
        "DESC": "(الإجمالي)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "وقت الاستجابة الأولى",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الرد الأول هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_TIME": {
        "NAME": "وقت إغلاق المحادثات",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الحل هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "آخر 7 أيام"
      },
      {
        "id": 1,
        "name": "آخر 30 يوماً"
      },
      {
        "id": 2,
        "name": "آخر 3 أشهر"
      },
      {
        "id": 3,
        "name": "آخر 6 أشهر"
      },
      {
        "id": 4,
        "name": "العام الماضي"
      },
      {
        "id": 5,
        "name": "تحديد نطاق المدة"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "تطبيق",
      "PLACEHOLDER": "اختر نطاق المدة"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "نظرة عامة على صندوق الوارد",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "تحميل بيانات الرسم البياني...",
    "NO_ENOUGH_DATA": "لم يتم جمع بيانات بقدر كافي لإنشاء التقرير، الرجاء المحاولة مرة أخرى لاحقاً.",
    "DOWNLOAD_INBOX_REPORTS": "تحميل تقارير صندوق الوارد",
    "FILTER_DROPDOWN_LABEL": "اختر صندوق الوارد",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "المحادثات",
        "DESC": "(الإجمالي)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "الرسائل الواردة",
        "DESC": "(الإجمالي)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "الرسائل الصادرة",
        "DESC": "(الإجمالي)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "وقت الاستجابة الأولى",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الرد الأول هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_TIME": {
        "NAME": "وقت إغلاق المحادثات",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الحل هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "آخر 7 أيام"
      },
      {
        "id": 1,
        "name": "آخر 30 يوماً"
      },
      {
        "id": 2,
        "name": "آخر 3 أشهر"
      },
      {
        "id": 3,
        "name": "آخر 6 أشهر"
      },
      {
        "id": 4,
        "name": "العام الماضي"
      },
      {
        "id": 5,
        "name": "تحديد نطاق المدة"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "تطبيق",
      "PLACEHOLDER": "اختر نطاق المدة"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "نظرة عامة للفريق",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "تحميل بيانات الرسم البياني...",
    "NO_ENOUGH_DATA": "لم يتم جمع بيانات بقدر كافي لإنشاء التقرير، الرجاء المحاولة مرة أخرى لاحقاً.",
    "DOWNLOAD_TEAM_REPORTS": "تحميل تقارير الفريق",
    "FILTER_DROPDOWN_LABEL": "اختيار فريق",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "المحادثات",
        "DESC": "(الإجمالي)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "الرسائل الواردة",
        "DESC": "(الإجمالي)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "الرسائل الصادرة",
        "DESC": "(الإجمالي)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "وقت الاستجابة الأولى",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الرد الأول هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_TIME": {
        "NAME": "وقت إغلاق المحادثات",
        "DESC": "(متوسط)",
        "INFO_TEXT": "العدد الإجمالي للمحادثات المستخدمة في الحساب:",
        "TOOLTIP_TEXT": "وقت الحل هو {metricValue} (على أساس {conversationCount} محادثات)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "عدد مرات الإغلاق",
        "DESC": "(الإجمالي)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "آخر 7 أيام"
      },
      {
        "id": 1,
        "name": "آخر 30 يوماً"
      },
      {
        "id": 2,
        "name": "آخر 3 أشهر"
      },
      {
        "id": 3,
        "name": "آخر 6 أشهر"
      },
      {
        "id": 4,
        "name": "العام الماضي"
      },
      {
        "id": 5,
        "name": "تحديد نطاق المدة"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "تطبيق",
      "PLACEHOLDER": "اختر نطاق المدة"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "تقارير CSAT",
    "NO_RECORDS": "لا توجد ردود متوفرة على الدراسة الاستقصائية CSAT.",
    "DOWNLOAD": "تحميل تقرير رضاء خدمة العملاء",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "اختر الوكلاء"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "جهات الاتصال",
        "AGENT_NAME": "الوكيل المكلف",
        "RATING": "التقييم",
        "FEEDBACK_TEXT": "تعليق الملاحظات"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "إجمالي الردود",
        "TOOLTIP": "العدد الإجمالي للردود التي تم جمعها"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "درجة الرضا",
        "TOOLTIP": "العدد الإجمالي للردود الإيجابية/ العدد الإجمالي للردود * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "معدل الاستجابة",
        "TOOLTIP": "العدد الإجمالي للردود / العدد الإجمالي لرسائل الاستقصاء التي أرسلتها CSAT * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "عدد المحادثات",
        "TOOLTIP": "العدد الإجمالي للمحادثات التي تحتوي على رسائل من الروبوت"
      },
      "OUTGOING_COUNT": {
        "LABEL": "عدد الإجابات",
        "TOOLTIP": "العدد الإجمالي للرسائل الصادرة"
      },
      "MESSAGE_COUNT": {
        "LABEL": "عدد إجابات الذكاء الاصطناعي",
        "TOOLTIP": "العدد الإجمالي لرسائل الإجابة التي أرسلها الروبوت"
      },
      "COPILOT_COUNT": {
        "LABEL": "عدد الردود المُعدّة مسبقاً",
        "TOOLTIP": "العدد الإجمالي لاقتراحات المساعد الذكي التي أعدّها الروبوت للوكلاء"
      },
      "SUCCESS_RATE": {
        "LABEL": "تم الحل بالذكاء الاصطناعي",
        "TOOLTIP": "نسبة المحادثات التي حلّها الذكاء الاصطناعي دون تحويلها إلى وكيل"
      },
      "RESOLVE_TIME": {
        "LABEL": "وقت الحل",
        "TOOLTIP": "الوقت الوسيط من أول رسالة للعميل إلى آخر رسالة من الروبوت/الوكيل"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "عدم التجميع",
      "INBOXES": "صناديق الوارد",
      "LABELS": "التسميات"
    },
    "GROUPED": {
      "CHART_TITLE": "التوزيع حسب المجموعة",
      "BACK_TO_ALL": "عرض الكل",
      "TABLE": {
        "INBOX": "صندوق الوارد",
        "LABEL": "التسمية",
        "CONVERSATIONS": "المحادثات",
        "MESSAGES": "الرسائل",
        "MESSAGES_TOOLTIP": "العدد الإجمالي للرسائل الصادرة",
        "AI_MESSAGES": "إجابات الذكاء الاصطناعي",
        "AI_MESSAGES_TOOLTIP": "العدد الإجمالي لإجابات الذكاء الاصطناعي، يليه عدد التقييمات الإيجابية والسلبية من المستخدمين النهائيين",
        "THUMBS_UP_TOOLTIP": "عدد إجابات الذكاء الاصطناعي التي قيّمها المستخدمون النهائيون بشكل إيجابي (إعجاب)",
        "THUMBS_DOWN_TOOLTIP": "عدد إجابات الذكاء الاصطناعي التي قيّمها المستخدمون النهائيون بشكل سلبي (عدم إعجاب)",
        "PREPARED": "الإجابات المُعدّة مسبقاً",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "نسبة رسائل هذه المجموعة من إجمالي جميع الرسائل",
        "BOT_RESPONSES": "نسبة إجابات الذكاء الاصطناعي %",
        "SUGGESTION_USED": "الإجابات المستخدمة",
        "SUGGESTION_USED_TOOLTIP": "نسبة الإجابات المُعدّة مسبقاً في هذه المجموعة التي استخدمها الوكلاء",
        "SUGGESTION_NOT_USED": "الإجابات غير المستخدمة",
        "SUGGESTION_NOT_USED_TOOLTIP": "نسبة الرسائل في هذه المجموعة التي كانت تملك رداً مُعداً مسبقاً ولكن لم يُستخدم"
      },
      "NOTES": {
        "TITLE": "كيفية احتساب المقاييس",
        "CONVERSATIONS": "عدد المحادثات التي تحتوي على رسالة صادرة واحدة على الأقل خلال الفترة المحددة.",
        "MESSAGES": "العدد الإجمالي للرسائل الصادرة (غير الخاصة) المرسلة خلال الفترة المحددة. يشمل ذلك الرسائل التي أنشأها الذكاء الاصطناعي والرسائل التي كتبها البشر.",
        "PERCENTAGE": "حصة رسائل هذه المجموعة من إجمالي الرسائل الصادرة عبر جميع المجموعات.",
        "AI_MESSAGES": "عدد الرسائل الصادرة التي أرسلها روبوت الذكاء الاصطناعي تلقائياً (باستثناء الردود المُعدّة مسبقاً للوكلاء). تُظهر الأرقام بين قوسين عدد الإجابات التي قيّمها المستخدمون النهائيون بشكل إيجابي (إعجاب) وسلبي (عدم إعجاب).",
        "PREPARED": "عدد اقتراحات المساعد الذكي (الردود المُعدّة مسبقاً) التي أنشأها روبوت الذكاء الاصطناعي للوكلاء خلال الفترة المحددة. هذه رسائل خاصة مرئية للوكلاء فقط ولا تُحتسب كرسائل صادرة، لذا قد لا يتطابق هذا الرقم مع عمود الرسائل.",
        "SUGGESTION_USED": "نسبة الإجابات المُعدّة مسبقاً في هذه المجموعة التي استخدمها الوكلاء. قد لا يتطابق هذا مع عدد الإجابات المُعدّة مسبقاً لأنه قد يشمل أيضاً اقتراحات أُنشئت في فترات سابقة.",
        "SUGGESTION_NOT_USED": "نسبة الرسائل الصادرة في هذه المجموعة التي كان لها اقتراح من المساعد الذكي لكن الوكيل رد دون استخدامه. تُحتسب فقط عندما يرسل الوكيل رداً فعلياً. قد لا يتطابق هذا مع عدد الإجابات المُعدّة مسبقاً لأنه قد يشمل أيضاً اقتراحات أُنشئت في فترات سابقة."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "نظرة عامة",
    "LIVE": "مباشر",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "المحادثات المفتوحة",
      "LOADING_MESSAGE": "جارٍ تحميل مقاييس المحادثات...",
      "OPEN": "فتح",
      "UNATTENDED": "بدون حضور",
      "UNASSIGNED": "غير مسند",
      "PENDING": "معلق"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "تنزيل التقرير"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "المحادثات من قبل الوكلاء",
      "LOADING_MESSAGE": "جاري تحميل مقاييس الوكيل...",
      "NO_AGENTS": "لا توجد أي محادثات من قبل الوكلاء",
      "TABLE_HEADER": {
        "AGENT": "موظف الدعم",
        "OPEN": "فتح",
        "UNATTENDED": "بدون حضور",
        "STATUS": "الحالة"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "الفريق",
        "OPEN": "فتح",
        "UNATTENDED": "بدون حضور",
        "STATUS": "الحالة"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "حالة الوكيل",
      "ONLINE": "متصل",
      "BUSY": "مشغول",
      "OFFLINE": "غير متصل"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "إضافة فلتر",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "لم يتم العثور على النتائج",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "اسم الموظف",
        "INBOXES": "اسم صندوق الوارد",
        "LABELS": "اسم الوسم",
        "TEAMS": "اسم الفريق"
      },
      "SLA": "SLA Policy",
      "INBOXES": "صندوق الوارد",
      "AGENTS": "موظف الدعم",
      "LABELS": "الوسم",
      "TEAMS": "الفريق"
    },
    "WITH": "مع",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "المحادثات",
        "AGENT": "وكيل الدعم"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "الإجمالي الفرعي",
    "NO_TEAM": "بدون فريق",
    "GROUP_BY_TEAMS": "تجميع حسب الفرق",
    "INBOX": "صندوق الوارد",
    "AGENT": "وكيل الدعم",
    "TEAM": "الفريق",
    "LABEL": "التسمية",
    "TOTAL": "الإجمالي",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "عدد مرات الإغلاق",
    "CONVERSATIONS": "عدد المحادثات",
    "OUTGOING_CHATS": "الدردشات الصادرة",
    "OUTGOING_EMAILS": "رسائل البريد الإلكتروني الصادرة",
    "PHONE_CALLS": "المكالمات الهاتفية",
    "INBOUND_CALLS": "المكالمات الواردة",
    "OUTBOUND_CALLS": "المكالمات الصادرة",
    "TOTAL_ACTIVITIES": "إجمالي الأنشطة",
    "ONLINE_TIME": "وقت الاتصال",
    "QUEUE_AVAILABLE_TIME": "وقت التوفر في قائمة الانتظار",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "عدد الرسائل الصادرة التي أرسلها هذا الوكيل",
      "OUTGOING_EMAILS": "عدد رسائل البريد الإلكتروني الصادرة التي أرسلها هذا الوكيل",
      "PHONE_CALLS": "العدد الإجمالي للمكالمات الهاتفية المعيَّنة لهذا الوكيل (مجموع المكالمات الواردة والصادرة)",
      "TOTAL_ACTIVITIES": "العدد الإجمالي للأنشطة: المكالمات الواردة + المكالمات الصادرة + الدردشات الصادرة + رسائل البريد الإلكتروني الصادرة",
      "INBOUND_CALLS": "عدد المكالمات الهاتفية الواردة المعيَّنة لهذا الوكيل",
      "OUTBOUND_CALLS": "عدد المكالمات الهاتفية الصادرة المعيَّنة لهذا الوكيل",
      "AVG_FIRST_RESPONSE_TIME": "متوسط الوقت من إنشاء المحادثة إلى أول رد من الوكيل في المحادثات المعيَّنة لهذا الوكيل",
      "AVG_RESOLUTION_TIME": "متوسط الوقت من إنشاء المحادثة إلى حلها في المحادثات المعيَّنة لهذا الوكيل",
      "AVG_REPLY_TIME": "متوسط وقت انتظار العملاء بين رسالتهم ورد الوكيل في المحادثات المعيَّنة لهذا الوكيل",
      "ONLINE_TIME": "إجمالي الوقت الذي كان فيه الوكيل متصلاً أو مشغولاً خلال الفترة المحددة",
      "QUEUE_AVAILABLE_TIME": "إجمالي الوقت الذي كان فيه الوكيل متاحاً في قوائم انتظار الهاتف خلال الفترة المحددة"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "تقارير الهاتف",
    "DESCRIPTION": "تتبّع مقاييس المكالمات الهاتفية بتحليلات تفصيلية للمكالمات الواردة والصادرة، مجمّعة حسب الوكيل أو صندوق الوارد لتحليل شامل.",
    "DOWNLOAD_PHONE_REPORTS": "تنزيل تقارير الهاتف",
    "GROUP_BY": {
      "LABEL": "تجميع حسب",
      "AGENT": "الوكيل",
      "INBOX": "صندوق الوارد"
    },
    "TABLE": {
      "TOTAL_CALLS": "الإجمالي",
      "INBOUND_CALLS": "واردة",
      "OUTBOUND_CALLS": "صادرة",
      "FAILED_OUTBOUND_CALLS": "صادرة فاشلة",
      "AVG_AGENT_HANDLED_DURATION": "متوسط المدة",
      "TOTAL_AGENT_HANDLED_DURATION": "إجمالي المدة",
      "AVG_RINGING_TIME": "متوسط وقت الرنين",
      "CONNECTED_OUTBOUND_PERCENTAGE": "نسبة النجاح %",
      "UNIQUE_CALLERS": "المتصلون الفريدون",
      "UNIQUE_CALLED_CONTACTS": "جهات الاتصال الفريدة المتصل بها",
      "UNANSWERED_MISSED_CALLS": "فائتة بلا متابعة",
      "UNANSWERED_MISSED_PERCENTAGE": "نسبة الفائتة غير المجاب عليها %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "فائتة بلا متابعة كافية لإعادة الاتصال",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "نسبة الفائتة بلا متابعة كافية لإعادة الاتصال %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "العدد الإجمالي لجميع المكالمات (بما فيها غير المتصلة)",
      "INBOUND_CALLS": "عدد المكالمات المتصلة",
      "OUTBOUND_CALLS": "عدد جميع المكالمات الصادرة (بما فيها غير المتصلة)",
      "FAILED_OUTBOUND_CALLS": "عدد المكالمات الصادرة التي فشل اتصالها",
      "AVG_AGENT_HANDLED_DURATION": "متوسط مدة المكالمات التي عالجها الوكلاء",
      "TOTAL_AGENT_HANDLED_DURATION": "إجمالي مدة جميع المكالمات التي عالجها الوكلاء",
      "AVG_RINGING_TIME": "متوسط الوقت الذي تقضيه المكالمات في الرنين قبل الرد عليها",
      "CONNECTED_OUTBOUND_PERCENTAGE": "نسبة المكالمات الصادرة التي تم الاتصال بها بنجاح",
      "UNIQUE_CALLERS": "عدد جهات الاتصال الفريدة التي أجرت مكالمات واردة",
      "UNIQUE_CALLED_CONTACTS": "عدد جهات الاتصال الفريدة التي تم الاتصال بها عبر مكالمات صادرة",
      "UNANSWERED_MISSED_CALLS": "عدد المكالمات الفائتة التي لم تتم فيها إعادة اتصال ناجحة (اتصال متصل). قد يشمل هذا مكالمات لا يزال يمكن التعامل معها ضمن يوم العمل",
      "UNANSWERED_MISSED_PERCENTAGE": "نسبة المتصلين الفريدين الذين فاتت مكالماتهم بلا متابعة (المكالمات الفائتة غير المجاب عليها / المتصلون الفريدون)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "عدد المكالمات الفائتة التي حاول أقل من مرتين إعادة الاتصال بها. قد يشمل هذا مكالمات لا يزال يمكن التعامل معها ضمن يوم العمل",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "نسبة المتصلين الفريدين الذين تمت محاولة إعادة الاتصال بهم أقل من مرتين ((الفائتة بلا متابعة - المعالجة بشكل كافٍ) / المتصلون الفريدون)"
    }
  }
}
